import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIDateInput from 'UIComponents/dates/UIDateInput';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITimeInput from 'UIComponents/input/UITimeInput';
import UIMultiColumn from 'UIComponents/layout/UIMultiColumn';
import UIMultiColumnGroup from 'UIComponents/layout/UIMultiColumnGroup';
import UIMultiColumnItem from 'UIComponents/layout/UIMultiColumnItem';
import { useEffect, useState } from 'react';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
// @ts-expect-error Untyped module
import PageExpiryExternalUrlModal from 'ContentEditorUI/components/settings/PageExpiryExternalUrlModal';
// @ts-expect-error Untyped module
import { fetch, search } from 'ContentEditorUI/api/PagesApi';
import { useSelector } from 'react-redux';
import { getIsLandingPage, getIsSitePage } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const UnpublishRedirectUrlField = ({
  disabled,
  pageExpiryRedirectUrl,
  pageExpiryRedirectId,
  setPageExpiryRedirectUrl,
  setPageExpiryRedirectId,
  unpublishExpiryUrl,
  setUnpublishExpiryUrl
}) => {
  const [redirectUrlSearchQuery, setRedirectUrlSearchQuery] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [pageExpiryRedirectName, setPageExpiryRedirectName] = useState(null);
  useEffect(() => {
    if (pageExpiryRedirectId && !pageExpiryRedirectName) {
      fetch(pageExpiryRedirectId).then(page => setPageExpiryRedirectName(page.name)).catch(() => {
        // no op
      });
    }
  });
  const [pagesMap, setPagesMap] = useState({});
  const redirectUrlLoadOptions = (input, callback) => {
    setRedirectUrlSearchQuery(input);
    const urlToPageMap = {};
    // TODO: as part of reducing content-type specific logic in CEUI, I'll try to clean this up and ask for options loader from the consumer app
    // see comment: https://git.hubteam.com/HubSpot/ContentEditorUI/pull/19030#pullrequestreview-4240159
    search(input).then(resp => {
      callback(null, {
        options: resp.objects.map(page => {
          urlToPageMap[page.url] = page;
          return {
            text: page.name ? `${page.name} (${page.url})` : page.url,
            value: page.url
          };
        }).filter(page => {
          return unpublishExpiryUrl ? page.value !== unpublishExpiryUrl : page.value !== pageExpiryRedirectUrl;
        })
      });
      setPagesMap(Object.assign({}, pagesMap, urlToPageMap));
    }).catch(() => {
      // no op
    });
  };
  const redirectUrlOptions = () => {
    // These options are used for the `options` attribute of UISelect,
    // and are used to provide available options for the selected value
    // before the user types to search. Without these options, the UISelect
    // could only show the value (which would be the selected expiry URL).
    const options = [];
    if (unpublishExpiryUrl) {
      options.push({
        text: unpublishExpiryUrl,
        value: unpublishExpiryUrl
      });
    } else {
      if (pageExpiryRedirectId && pageExpiryRedirectName && pageExpiryRedirectUrl) {
        options.push({
          text: pageExpiryRedirectName ? `${pageExpiryRedirectName} (${pageExpiryRedirectUrl})` : pageExpiryRedirectUrl,
          value: pageExpiryRedirectUrl
        });
      } else if (pageExpiryRedirectId === 0 && pageExpiryRedirectUrl) {
        // If the pageExpiryRedirectId is 0, then it's an external URL.
        options.push({
          text: pageExpiryRedirectUrl,
          value: pageExpiryRedirectUrl
        });
      }
    }
    return options;
  };
  const handleRedirectChange = ({
    target: {
      value
    }
  }) => {
    setPageExpiryRedirectUrl(value);
    setPageExpiryRedirectId(value === '' ? undefined : pagesMap[value].id);
    setUnpublishExpiryUrl(value);
  };
  const handleCreateExternalUrl = (externalUrlPrefix, externalUrlPath) => {
    setPageExpiryRedirectId(0);
    setPageExpiryRedirectUrl(`${externalUrlPrefix}${externalUrlPath}`);
    setUnpublishExpiryUrl(`${externalUrlPrefix}${externalUrlPath}`);
    setModalOpen(false);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIFormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "patagoniaPublishingOptionsModal.unpublishRedirect.header"
      }),
      className: "m-top-4 m-bottom-6",
      children: /*#__PURE__*/_jsx(UISelect, {
        "data-test-id": "page-expiration-url",
        className: "pageExpiryRedirectUrl",
        autoload: true,
        clearable: true,
        defaultValue: unpublishExpiryUrl || pageExpiryRedirectUrl,
        dropdownFooter: /*#__PURE__*/_jsxs(UIButton, {
          onClick: () => setModalOpen(true),
          use: "link",
          children: [/*#__PURE__*/_jsx(UIIcon, {
            name: "add"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "patagoniaPublishingOptionsModal.unpublishRedirect.externalUrlText"
          })]
        }),
        loadOptions: redirectUrlLoadOptions,
        options: redirectUrlOptions(),
        noResultsText: I18n.text(redirectUrlSearchQuery.length === 0 ? 'patagoniaPublishingOptionsModal.unpublishRedirect.redirectUrlTypeToSearch' : 'patagoniaPublishingOptionsModal.unpublishRedirect.redirectUrlNoResultsFound'),
        onChange: handleRedirectChange,
        placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "patagoniaPublishingOptionsModal.unpublishRedirect.redirectUrlPlaceholder"
        }),
        value: unpublishExpiryUrl || pageExpiryRedirectUrl,
        readOnly: disabled
      })
    }), modalOpen ? /*#__PURE__*/_jsx(PageExpiryExternalUrlModal // TODO: Rename this modal to be more generic
    , {
      closeModal: () => setModalOpen(false),
      onCreateExternalUrl: handleCreateExternalUrl
    }) : null]
  });
};
const SchedulingUnpublishControls = ({
  scheduledUnpublishDate,
  setScheduledUnpublishDate,
  scheduledUnpublishTime,
  setScheduledUnpublishTime,
  isReadOnlyMode,
  onExitSchedulingClick,
  minimumDateForUnpublish,
  minimumTimeForUnpublish,
  pageExpiryRedirectUrl,
  pageExpiryRedirectId,
  setPageExpiryRedirectUrl,
  setPageExpiryRedirectId,
  unpublishExpiryUrl,
  setUnpublishExpiryUrl
}) => {
  const isLandingPage = useSelector(getIsLandingPage);
  const isSitePage = useSelector(getIsSitePage);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIMultiColumn, {
      flush: true,
      children: /*#__PURE__*/_jsxs(UIMultiColumnGroup, {
        children: [/*#__PURE__*/_jsx(UIMultiColumnItem, {
          horizontalAlign: "left",
          verticalAlign: "middle",
          className: "p-x-2",
          children: /*#__PURE__*/_jsx(UIDateInput, {
            "data-test-id": "unpublishing-date-picker",
            min: minimumDateForUnpublish,
            onChange: ({
              target: {
                value
              }
            }) => {
              setScheduledUnpublishDate(value);
            },
            value: scheduledUnpublishDate,
            readOnly: isReadOnlyMode
          })
        }), /*#__PURE__*/_jsx(UIMultiColumnItem, {
          horizontalAlign: "left",
          verticalAlign: "middle",
          className: "p-x-2",
          children: /*#__PURE__*/_jsx(UITimeInput, {
            value: scheduledUnpublishTime,
            "data-test-id": "unpublishing-time-picker",
            use: "default",
            onChange: e => {
              setScheduledUnpublishTime(e.target.value);
            },
            readOnly: isReadOnlyMode,
            format: `LT [${I18n.moment.portalTz().format('z')}]`,
            interval: 15,
            min: minimumTimeForUnpublish
          })
        }), /*#__PURE__*/_jsx(UIMultiColumnItem, {
          horizontalAlign: "right",
          verticalAlign: "middle",
          className: "p-x-2",
          children: /*#__PURE__*/_jsx(UIIconButton, {
            use: "unstyled",
            onClick: onExitSchedulingClick,
            children: /*#__PURE__*/_jsx(UIIcon, {
              name: "remove"
            })
          })
        })]
      })
    }), isLandingPage || isSitePage ? /*#__PURE__*/_jsx(UnpublishRedirectUrlField, {
      disabled: isReadOnlyMode,
      pageExpiryRedirectUrl: pageExpiryRedirectUrl,
      pageExpiryRedirectId: pageExpiryRedirectId,
      setPageExpiryRedirectUrl: setPageExpiryRedirectUrl,
      setPageExpiryRedirectId: setPageExpiryRedirectId,
      unpublishExpiryUrl: unpublishExpiryUrl,
      setUnpublishExpiryUrl: setUnpublishExpiryUrl
    }) : null]
  });
};
export default SchedulingUnpublishControls;